import { useState } from "react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import { Phone, WhatsappLogo, EnvelopeSimple, MapPin, CheckCircle } from "@phosphor-icons/react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/contact", form);
      setSent(true); setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      setError(err.response?.data?.detail || "Bir hata oluştu");
    } finally { setLoading(false); }
  };

  return (
    <>
      <SEO title="İletişim | Bize Ulaşın | Estem Sürücü Kursu Gebze"
        description="Estem Sürücü Kursu Gebze iletişim bilgileri: 0262 646 3 646. Hacıhalil Mh. Gebze/Kocaeli."
        canonical="https://www.estemsurucukursu.com/iletisim"/>
      <section className="px-4 md:px-8 py-12 md:py-20 max-w-7xl mx-auto">
        <div className="nb-badge mb-4">İletişim</div>
        <h1 className="font-heading font-bold text-5xl md:text-7xl tracking-tight leading-[1.05]">
          Bize ulaş.<br/><span className="text-brand-primary">Sana dönelim.</span>
        </h1>
        <div className="mt-12 grid lg:grid-cols-2 gap-8">
          <div className="space-y-4">
            <a href="tel:+902626463646" className="nb-card p-6 flex items-center gap-4 hover:bg-brand-primarySubtle transition-colors" data-testid="contact-phone">
              <div className="w-14 h-14 bg-brand-primary border border-stone-200 rounded-2xl flex items-center justify-center text-white"><Phone size={28} weight="bold"/></div>
              <div><div className="nb-label">Telefon</div><div className="font-heading font-bold text-2xl">0262 646 3 646</div></div>
            </a>
            <a href="https://wa.me/+905436566346" target="_blank" rel="noreferrer" className="nb-card p-6 flex items-center gap-4 hover:bg-brand-primarySubtle transition-colors" data-testid="contact-whatsapp">
              <div className="w-14 h-14 bg-brand-primarySubtle border border-stone-200 rounded-2xl flex items-center justify-center"><WhatsappLogo size={28} weight="bold"/></div>
              <div><div className="nb-label">WhatsApp</div><div className="font-heading font-bold text-2xl">0543 656 6 346</div></div>
            </a>
            <a href="mailto:info@estemsurucukursu.com" className="nb-card p-6 flex items-center gap-4 hover:bg-brand-primarySubtle transition-colors" data-testid="contact-email">
              <div className="w-14 h-14 bg-white border border-stone-200 rounded-2xl flex items-center justify-center"><EnvelopeSimple size={28} weight="bold"/></div>
              <div><div className="nb-label">E-posta</div><div className="font-heading font-bold text-base md:text-lg break-all">info@estemsurucukursu.com</div></div>
            </a>
            <a href="https://goo.gl/maps/prHGbUQpr71FUoAv7" target="_blank" rel="noreferrer" className="nb-card p-6 flex items-start gap-4 hover:bg-brand-primarySubtle transition-colors" data-testid="contact-address">
              <div className="w-14 h-14 bg-brand-ink border border-stone-200 rounded-2xl flex items-center justify-center text-white shrink-0"><MapPin size={28} weight="bold"/></div>
              <div><div className="nb-label">Adres</div><div className="font-heading font-bold text-sm md:text-base">Hacıhalil Mahallesi Zübeyde Hanım Caddesi Gümgüm İş Merkezi Kat:1, 41400 Gebze/Kocaeli</div></div>
            </a>
            <div className="nb-card overflow-hidden">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3010.1!2d29.4326!3d40.7985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cb208952ab4a17%3A0x388b0addf8617830!2sGebze%20Estem%20S%C3%BCr%C3%BCc%C3%BC%20Kursu!5e0!3m2!1str!2str!4v1700000000"
                width="100%" height="280" style={{border:0}} loading="lazy" title="Estem Sürücü Kursu Gebze konumu"/>
            </div>
          </div>

          <form onSubmit={submit} className="nb-card p-8 bg-white" data-testid="contact-form">
            <h2 className="font-heading font-bold text-3xl tracking-tight">Mesaj Gönder</h2>
            {sent && <div className="mt-4 p-4 bg-brand-success/10 border-2 border-brand-success rounded-xl flex items-center gap-2 text-brand-success font-bold"><CheckCircle weight="fill"/> Mesajınız iletildi. En kısa sürede dönüş yapacağız.</div>}
            {error && <div className="mt-4 p-4 bg-brand-error/10 border-2 border-brand-error rounded-xl text-brand-error font-bold">{error}</div>}
            <div className="mt-6 space-y-4">
              <div><label className="nb-label">Ad Soyad</label><input required value={form.name} onChange={e=>setForm({...form, name:e.target.value})} className="nb-input mt-1" data-testid="contact-name"/></div>
              <div><label className="nb-label">E-posta</label><input required type="email" value={form.email} onChange={e=>setForm({...form, email:e.target.value})} className="nb-input mt-1" data-testid="contact-email-input"/></div>
              <div><label className="nb-label">Telefon</label><input value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})} className="nb-input mt-1" data-testid="contact-phone-input"/></div>
              <div><label className="nb-label">Mesajınız</label><textarea required rows={5} value={form.message} onChange={e=>setForm({...form, message:e.target.value})} className="nb-input mt-1" data-testid="contact-message"/></div>
              <button disabled={loading} className="nb-btn w-full" data-testid="contact-submit">{loading ? "Gönderiliyor..." : "Gönder"}</button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
}
